import { Component } from "preact";
import Button from "../button";
import { validateFormFields } from "../../../utils/formValidation";
import _constant from "../../../utils/constants";
import { post } from "../../../utils/http";
import common from "../../../utils/common";
import style from "./style";
import { locale } from "../../../utils/i18n";
import { logEvent } from "../../../utils/logger";
import DefaultAmountInput from "../inputs/default-amount";
import { getKey } from "../../../utils/utility";
import { mConfig } from "../../../utils/checkout";

export default class PaymentFields extends Component {
  constructor(props) {
    super(props);
    this.inputFields = [];
    this.state = {
      fields: props.fields,
      showPaymentFormError: false,
      PaymentFormError: "",
      showButtonLoader: false,
      buttonDisabled: false
    };
    this.amountFieldFirtsIndex = common.getAmountFieldFirtsIndex(this.state.fields);
    this.setInputFields(this.state.fields, props.getFormFields);
    this.updateFormValue = this.updateFormValue.bind(this);
    this.clearPaymentFormError = this.clearPaymentFormError.bind(this);
  }

  setInputFields = (fields, getFormFields) => {
    this.inputFields = [];
    const length = fields.length || 0;
    let element = [];
    for (let i = 0; i < fields.length; i++) {
      if (
        !(this.props.partialAmountData && this.props.partialAmountData.isPartialPayment) &&
        (i === this.amountFieldFirtsIndex && this.props.amount)
      ) {
        this.inputFields.push(
          <div className="ib w100 pos-r">
            <div className="custom-length" style="width:100%">
              <div className="spacer">
                <li>
                  <DefaultAmountInput inputValue={this.props.amount} />
                </li>
              </div>
            </div>
          </div>
        );
      }
      const field = fields[i];
      element.push(
        getFormFields(
          field.inputValue,
          field.isError,
          field.errorName,
          field.type,
          field.name,
          field.constraints,
          field.placeholder,
          field.subText,
          i,
          field.size,
          this.updateFormValue,
          this.clearErrorData,
          this.props.updateAmount
        )
      );
      if (field.parentSubText) {
        element.push(<p className="input-info input-info-outer spacer">{field.parentSubText}</p>);
      }
      if (i < length - 1 && fields[i + 1].orientation && fields[i + 1].orientation === _constant.H_ORIENTATION) {
        this.inputFields.push(<li>{element}</li>);
        element = [];
      } else if (i === length - 1) {
        this.inputFields.push(<li>{element}</li>);
        element = [];
      }
    }
  };

  updateFormValue = (index, value) => {
    this.clearPaymentFormError();
    const fields = this.state.fields || [];
    if (fields.length > 0 && index < fields.length) {
      if (fields[index].inputValue !== undefined) {
        fields[index].inputValue = value;
        this.setState(() => {
          return { fields };
        });
        this.setInputFields(this.state.fields, this.props.getFormFields);
      }
    }
  };

  clearErrorData = index => {
    const fields = this.state.fields || [];
    if (fields.length > 0 && index < fields.length) {
      if (fields[index].inputValue !== undefined) {
        fields[index].isError = false;
        fields[index].errorName = "";
        this.setState(() => {
          return { fields };
        });
        this.setInputFields(this.state.fields, this.props.getFormFields);
      }
    }
  };

  submitPaymentForm = e => {
    e.preventDefault();
    if (this.state.buttonDisabled) {
      return;
    }
    if( this.props.showPayLimitExceedError ) {
      return;
    }
    this.clearPaymentFormError();
    const errorData = validateFormFields(this.state.fields);
    if (errorData.isFormError) {
      this.setState({ fields: errorData.fields });
      this.setInputFields(this.state.fields, this.props.getFormFields);
      logEvent({
        eventType: "Form_Validation_Failed",
        eventValue: "form field error",
        data: errorData.fields.map(item => {
          return {
            fieldName: item.name,
            isError: item.isError,
            errorName: item.errorName,
            constraints: item.constraints
          };
        })
      });
    } else {
      this.setState({ showButtonLoader: true, buttonDisabled: true });
      const formData = { fields: [], linkId: this.props.linkId ? this.props.linkId : "" };
      if (this.amountFieldFirtsIndex !== -1) {
        formData.totalAmount = this.props.buttonAmount;
      }
      formData.mid = this.props.mid;
      formData.fields = common.setPostPaymentFormData(this.state.fields);
      logEvent({ eventType: "Proceed_to_Pay", eventValue: "Submit form Button click" });
      logEvent({
        eventType: "Payment_Form_submit",
        eventValue: "Validation success",
        data: this.state.fields.map(item => {
          return { fieldName: item.name };
        })
      });
      // common.invokeCheckoutJS(config);
      const loader = document.getElementById("ptm-loader");
      post(`${common.getAPIHOST()}/${_constant.PAYMENT_FORM_SUBMIT_URL}`, formData)
        .then(data => {
          this.setState({ showButtonLoader: false, buttonDisabled: false });
          logEvent({ eventType: "Post_Form_Submit", eventValue: "API success", status: "success" });

          const triggerJSCheckout = getKey(this.props, "triggerJSCheckout", undefined);
          if (triggerJSCheckout) {
            loader.style.display = "block";
            const config = mConfig || {};
            config.data.token = getKey(data, "body.txnToken", undefined);
            config.data.orderId = getKey(data, "body.orderId", undefined);
            config.data.amount = getKey(this.props, "amount", "");
            this.props.showCheckoutJS();
            common
              .invokeCheckoutJS(config)
              .then(result => {
                if (result) {
                  loader.style.display = "none";
                  this.props.toggleCheckoutjsLoader();
                }
              })
              .catch(error => {
                loader.style.display = "none";
                console.log({ error });
              });
          } else if (data.body.paymentLink) {
            const url =
              common.isWebView() && getKey(data, "body.longUrl", "")
                ? getKey(data, "body.longUrl", "")
                : getKey(data, "body.paymentLink", "");
            common.redirectToURL(url);
          }
        })
        .catch(error => {
          let errorMsg = "";
          this.setState({ showButtonLoader: false, buttonDisabled: false });
          if (error && error.body) {
            if (error.body.hasOwnProperty("errorFields") && error.body.errorFields) {
              const { fields } = this.state;
              const { errorFields } = error.body;
              for (const fieldName in errorFields) {
                const errorFieldIndex = fields.findIndex(item => item.name == fieldName);
                if (errorFieldIndex > -1) {
                  fields[errorFieldIndex].errorName = errorFields[fieldName];
                  fields[errorFieldIndex].isError = true;
                  this.setState({ fields });
                  this.setInputFields(this.state.fields, this.props.getFormFields);
                }
              }
            }
            if (error.body.resultInfo && error.body.resultInfo.resultStatus && error.body.resultInfo.resultMessage) {
              errorMsg = error.body.resultInfo.resultMessage;
            }
          } else {
            errorMsg = locale("error.something.went.wrong");
          }
          this.setState({
            showPaymentFormError: true,
            PaymentFormError: errorMsg
          });
          logEvent({ eventType: "Post_Form_Submit", eventValue: "API failed", error: errorMsg });
        });
    }
    // fields.map((field,index)=>{
    //     return getFormFields(field.type,field.name,field.constraints,field.placeholder,field.subtext,index,field.orientation,field.size);
    // })
  };

  clearPaymentFormError = () => {
    this.setState({ PaymentFormError: "", showPaymentFormError: false });
  };

  render({ templateInfo, buttonAmount }) {
    return (
      <div className="main ib">
        <p className={`${style["product-info"]}`}>{templateInfo}</p>
        <form id="paymentForm" data-isMob="dfs" data-isemail="dfs" onSubmit={this.submitPaymentForm}>
          <ul className={`${style["input-list"]}`}>{this.inputFields}</ul>

          <div className={`ib ${style.payBtn}`}>
            {this.state.showPaymentFormError && <div className="error form-error">{this.state.PaymentFormError}</div>}
            { this.props.showPayLimitExceedError && 
              <div className="error form-error">{this.props.payLimitExceedError}</div>
            }
            <Button
              type="submit"
              buttonText={locale("button.proceed.to.pay")}
              showLoader={this.state.showButtonLoader}
              disabled={this.state.buttonDisabled}
              buttonAmount={buttonAmount}
            />
          </div>
        </form>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./form/components/paymentfields/index.js